import React from 'react';
import { FaBars } from 'react-icons/fa';
import { Nav, NavBarContainer, MobileIcon, NavMenu, NavItem, NavLinks } from './NavBarElements';


const Navbar = ({ toggle }) => {
    return (
        <>
            <Nav>
                <NavBarContainer>
                    {/* <NavLogo to='/home'> Leon Hsu </NavLogo> */}
                    <div id="logo">
                        <h2><a href="/"><img id="logo-design" src="assets/designs/leonhsulogo.png" alt="Leon Hsu Logo"></img></a></h2>
                    </div>
                    <MobileIcon onClick={toggle}>
                        <FaBars />
                    </MobileIcon>
                    <NavMenu>
                        {/* <NavItem>
                            <NavLinks to="/">Home</NavLinks>
                        </NavItem> */}
                        <NavItem>
                            <NavLinks to="about">About</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="skills">Skills</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="portfolio">Portfolio</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="contact">Contact</NavLinks>
                        </NavItem>
                    </NavMenu>
                </NavBarContainer>

            </Nav>
        
        </>
    )
}

export default Navbar;
